import {useEffect} from "react";
import CalendarSection from "../components/Calendar/CalendarSection";
import KnockoutSection from "../components/Calendar/KnockoutSection";
import TopScorersSection from "../components/Calendar/TopScorersSection";

function Calendar(){
  useEffect(()=>{
    window.scrollTo(0,0);
  },[]);

  return(
    <>
      <KnockoutSection/>
      <CalendarSection/>
      <TopScorersSection/>
    </>
  );
}

export default Calendar;